import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'shitty-jobs-animation-settings';

const useAnimationControls = () => {
  const [animationsEnabled, setAnimationsEnabled] = useState(true);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const settings = JSON.parse(saved);
        setAnimationsEnabled(settings.enabled ?? true);
      }
    } catch (error) {
      console.warn('Failed to load animation settings from localStorage:', error);
    }
  }, []);

  const saveSettings = useCallback((enabled) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          enabled,
        })
      );
    } catch (error) {
      console.warn('Failed to save animation settings to localStorage:', error);
    }
  }, []);

  const toggleAnimations = useCallback(() => {
    setAnimationsEnabled((prev) => {
      const newValue = !prev;
      saveSettings(newValue);
      return newValue;
    });
  }, [saveSettings]);

  return {
    animationsEnabled,
    shouldAnimate: animationsEnabled,
    toggleAnimations,
  };
};

export default useAnimationControls;
